/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import React from 'react';

import { PageCalculatorType } from '../../../algorithm/types';
import { getNextPageLinks } from '../../../algorithm/runAlgorithm';
import styles from './CalculatorPageFooter.module.scss';
import { useMessageIndex } from '../../hooks/MessageContext';
import { SelectKeysSummaryTable } from './SelectKeysSummaryTable';
import { selectSelectedKeysForMessage } from '../../chatSlice';
import { useAppSelector } from '../../../../../app/hooks';

interface CalculatorPageFooterProps {
  page: PageCalculatorType;
}

/** Shows the error and comment set in getNextPageLinks() */
export function CalculatorPageFooter({ page }: CalculatorPageFooterProps) {
  const messageIndex = useMessageIndex();
  const selectedKeys = useAppSelector((state) => selectSelectedKeysForMessage(state, messageIndex));
  const { error, comment, anyUnselected } = getNextPageLinks(page, -1, selectedKeys);
  // Note, comment is like "score = 2.0"
  return (
    <div>
      {error && <div>{error}</div>}
      {comment && <div className={styles.comment}>{comment}</div>}
      {selectedKeys && !anyUnselected && !page.hide_summary && (
        <SelectKeysSummaryTable showOnlyMessageIndex={messageIndex} messageIndex={messageIndex} />
      )}
    </div>
  );
}
